import React, { PropTypes } from 'react'
import selectn from 'selectn'

export class GameBreak extends React.Component {
  constructor(props) {
    super(props)

    //init game status and breaks checks (all false if game in progress)
    this._isCurrEqPrevBreak = false
    this._isValidGameBreak = false
    this._isPrevBreakExists = false
    this._currentGamebreakstatus = ''
    this._prevGamebreakstatus = ''

    this._gamestatus = selectn('gamestatus',props)
    this._gamebreakstatus = selectn('gamebreakstatus',props)

    this._config = {}
    this._config.initialized = false
    this._config.showad = false

    this._config.gameId = 0
    this._config.type = null
    this._config.sport = null
    this._config.gamestatus = null
    this._config.gamebreakstatus = null

  }
  static propTypes = {
    children: PropTypes.object
  }
  videoHtml() {
    const html = `
      <div id="gamepackage-gamebreak" class="sub-module videoAdBreak" style="display: none;">
        <div class="content">
          <div class="video-ad-break-wrap">
            <div class="video-ad-status">
              <div class="time-til-skip">
                <span>
                  <span class="countdown"></span>
                  <a id="skipad-link" style="display: none; float: right; padding: 0px 5px; height: 20px; color: #fff;">Skip this Ad</a>
                </span>
              </div>
            </div>
            <div class="video-ad-break">
              <div class="wrapper">
                <div id="gbVideoPlayer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
    return html
  }

  createGameConfig() {
    const data = this.props || {}
    let params = selectn('params',this.props) || {}, gameconfig = {}
    if(params.gameId !== '') {
      gameconfig = {
        gameId : params.gameId ? params.gameId : undefined,
        type : params.pageType ? params.pageType : undefined,
        sport : params.sport ? params.sport : undefined,
        gamestatus: data.gamestatus ? data.gamestatus : undefined,
        gamebreakstatus: data.gamebreakstatus ? data.gamebreakstatus : undefined
      }
      //changing live state to in since all the sports uses pre, post and in for gameStates
      if(gameconfig.gamestatus === 'live') {
        gameconfig.gamestatus = 'in'
      }
    }
    this._config.gameId = gameconfig.gameId
    this._config.type = gameconfig.type
    this._config.sport = gameconfig.sport
    this._config.gamestatus = gameconfig.gamestatus
    this._config.gamebreakstatus = this._currentGamebreakstatus
  }
  
  /**
   * [callGamebreakAd call the gamebreak ad after inserting HTML for the ooyala player]
   * @return {[type]} [runs the ad]
   */
  callGamebreakAd() {
    this.createGameConfig()
    if(this._config.showad === true) {
      this.props.gamebreak({ addplayerhtml: this.videoHtml() })
      this.props.gamebreak(this._config)
    }
  }
  componentDidMount() {
    //when the page loads and component is loaded run the ad and inits the counter
    const pageType = this._config.pageType || ''
    this._currentGamebreakstatus = selectn('gamebreakstatus',this.props) || ''
    if((pageType === 'game') && (this._config.showad === true)) {
      this.callGamebreakAd()
    }
  }
  shouldComponentUpdate(nextProps) {
    //the ad component shouldn't refresh during polling
    const pageType = selectn('params.pageType',nextProps) || ''
    this._currentGamebreakstatus = selectn('gamebreakstatus',nextProps) || ''
    this._prevGamebreakstatus = selectn('gamebreakstatus',this.props) || ''
    const gamestatusArr = [ 'lunch', 'dinner', 'drinks', 'tea', 'innings' ]

    //Flag is true when the gamebreak is one of the allowed values in gamestatusArr
    this._isValidGameBreak = (gamestatusArr.indexOf(this._currentGamebreakstatus) > -1)

    //Flag is true if the current game break info is equal to previous state (happens when the break is ongoing)
    this._isCurrEqPrevBreak = (this._currentGamebreakstatus === this._prevGamebreakstatus) && (this._currentGamebreakstatus !== '')

    //Flag is set true when the game has a previous state break info and no current break info status
    this._isPrevBreakExists = (this._currentGamebreakstatus !== this._prevGamebreakstatus) && (gamestatusArr.indexOf(this._prevGamebreakstatus) > -1)

    if(pageType === 'game') {

      // do not re render for any states, will reinsert the content in dom if needed
      if(this._isCurrEqPrevBreak && this._isValidGameBreak) {
        //works on first load
        this._config.showad = true
      }
      // when previous gamebreakstatus is available don't show the ad
      if(this._isPrevBreakExists) {
        this._config.showad = false
      }
      // all game gamebreakstatus are empty don't show ad
      if(!this._isPrevBreakExists && !this._isValidGameBreak && !this._isCurrEqPrevBreak) {
        this._config.showad = false
      }
      // first time gamebreakstatus available show the ad
      if((this._currentGamebreakstatus !== '') && (this._prevGamebreakstatus === '')) {
        this._config.showad = true
      }

      if(this._config.showad === false) {
        return false
      }

      this.callGamebreakAd()

      return false

    }
  }

  render() {

    this._gamestatus = selectn('gamestatus',this.props)
    this._gamebreakstatus = selectn('gamebreakstatus',this.props)

    //load the component if game is live
    if(this._gamestatus && (this._gamestatus === 'live')) {
      this._config.initialized = true

      return (
          <div>
            <article key="gmart" id="videogamebreak" style={ { backgroundColor: '#333' } } dangerouslySetInnerHTML={{ __html: this.videoHtml() }} />
          </div>
      )
    }
    
    
  }
}



// WEBPACK FOOTER //
// ../app/components/gamepackage/GameBreak.jsx